import styled from '@emotion/styled'

const PageContainer = styled.div`
  width: 100%;
  height: 30rem;
  background: #ffffff;
  padding-top: 7rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2.5rem;
`

export { PageContainer }
